<template>
	<div id="app">
		<!-- <img src="./assets/logo.png"> -->
		<router-view/>
		<portal-target name="modals" multiple></portal-target>
	</div>
</template>

<script>
	import * as Config from '@/config'
	import moment from 'moment';
	import { mapActions, mapGetters } from 'vuex';

	export default {
		name: 'app',
		data() {
			return {
				lastActiveTime: null,
			}
		},
		mounted() {
			this.lastActiveTime = moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss");

			this.init();
			
			setTimeout(function() {
				this.ping();
			}.bind(this), 1000);

			setInterval(function () {
					this.ping();
			}.bind(this), 60000);
		},
		methods: {
			...mapGetters([
				'isAuthenticated',
				'getAuthorizationHeader'
			]),

			init() {
				var _this = this;

				document.onload = _this.resetTimer;
				document.onmousemove = _this.resetTimer;
				document.onmousedown = _this.resetTimer;
				document.ontouchstart = _this.resetTimer;
				document.onclick = _this.resetTimer;
			},

			resetTimer() {
				this.lastActiveTime = moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss");
			},

			ping() {

				if(this.isAuthenticated()) {

					var data = {
						lastActive: this.lastActiveTime,
					}

					this.$http.post(Config.apiPath + "/api/v2/ping", data, this.getAuthorizationHeader()).then((response) => {
						
					});
				}
			
			}

		}
	}
</script>

<style>
	@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700,900');

	#app {
		font-family: 'Source Sans Pro', sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	* {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.badge-success-custom {
		background-color: #61D773;
	}

	.badge-primary-custom {
		background-color: #0055A3;
	}

	.btn-primary-custom {
		background-color: #0055A3;
	}

	.btn-success {
		background-color: #82C843;
		border: 0;
	}

	.btn-primary {
		background-color: #0055A3;
		border: 0;
	}

	.text-uppercase {
		text-transform: uppercase;
	}

	.br-2 {
		border-radius: 2px;
	}

	.br-lt-2 {
		border-top-left-radius: 2px;
	}

	.br-rt-2 {
		border-top-right-radius: 2px;
	}

	.alert {
		background-color: #fff;
		border: none;
		color: #000;
	}

	.alert:after {
		visibility: hidden;
		display: block;
		font-size: 0;
		content: " ";
		clear: both;
		height: 0;
	}

	.alert b {
		display: inherit;
	}


	.alert-primary {
		border-left: 4px solid #3498db;
	}

	.alert-primary b {
		color: #3498db;
		text-transform: uppercase;
		padding-right: 5px;
		font-size: 18px;
	}

	.alert-secondary {
		border-left: 4px solid #95a5a6;
	}

	.alert-secondary b {
		color: #95a5a6;
		text-transform: uppercase;
		padding-right: 5px;
		font-size: 18px;
	}

	.alert-success {
		border-left: 4px solid #2ecc71;
	}

	.alert-success b {
		color: #2ecc71;
		text-transform: uppercase;
		padding-right: 5px;
		font-size: 18px;
	}

	.alert-danger {
		border-left: 4px solid #e74c3c;
	}

	.alert-danger b {
		color: #e74c3c;
		text-transform: uppercase;
		padding-right: 5px;
		font-size: 18px;
	}

	.alert-warning {
		border-left: 4px solid #f1c40f;
	}

	.alert-warning b {
		color: #f1c40f;
		text-transform: uppercase;
		padding-right: 5px;
		font-size: 18px;
	}

	.alert-info {
		border-left: 4px solid #34495e;
	}

	.alert-info b {
		color: #34495e;
		text-transform: uppercase;
		padding-right: 5px;
		font-size: 18px;
	}


	.fw-300 {
		font-weight: 300;
	}

	.fw-400 {
		font-weight: 300;
	}

	.fw-500 {
		font-weight: 300;
	}

	.fw-600 {
		font-weight: 600;
	}

	.btn-secondary, .btn-danger {
		border: 0;
	}




	.img-circle {
		border-radius: 50%;
		max-width: 60px;
		max-height: 60px;
	}

	.dropdown-top-65 {
		top: 65px;
	}

	.dropdown-notifications a:after {
		display: none;
	}

	.dropdown-toolbar {
		padding: 15px;
		color: #fff;
		background-color: #004F96;
		border-bottom: 1px solid rgba(0, 0, 0, 0.15);
		border-radius: 4px 4px 0 0;
	}

	.dropdown-toolbar > .form-group {
		margin: 5px -10px;
	}
	.dropdown-toolbar .dropdown-toolbar-actions {
		float: right;
	}
	.dropdown-toolbar .dropdown-toolbar-title {
		margin: 0;
		font-size: 18px;
	}
	.dropdown-footer {
		padding: 10px 20px;
		border-top: 1px solid #ccc;
		border-top: 1px solid rgba(0, 0, 0, 0.15);
		border-radius: 0 0 4px 4px;
	}
	.anchor-block small {
		display: none;
	}


@media (min-width: 992px) {
  .anchor-block small {
    display: block;
    font-weight: normal;
    color: #777777;
  }
  .dropdown-menu > li > a.anchor-block {
    padding-top: 6px;
    padding-bottom: 6px;
  }
}
@media (min-width: 992px) {
  .dropdown.hoverable:hover > ul {
    display: block;
  }
}
.dropdown-position-topright {
  top: auto;
  right: 0;
  bottom: 100%;
  left: auto;
  margin-bottom: 2px;
}
.dropdown-position-topleft {
  top: auto;
  right: auto;
  bottom: 100%;
  left: 0;
  margin-bottom: 2px;
}
.dropdown-position-bottomright {
  right: 0;
  left: auto;
}
.dropmenu-item-label {
  white-space: nowrap;
}
.dropmenu-item-content {
  position: absolute;
  text-align: right;
  max-width: 60px;
  right: 20px;
  color: #777777;
  overflow: hidden;
  white-space: nowrap;
  word-wrap: normal;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
small.dropmenu-item-content {
  line-height: 20px;
}
.dropdown-menu > li > a.dropmenu-item {
  position: relative;
  padding-right: 66px;
}
.dropdown-submenu .dropmenu-item-content {
  right: 40px;
}
.dropdown-menu > li.dropdown-submenu > a.dropmenu-item {
  padding-right: 86px;
}
.dropdown-inverse .dropdown-menu {
  background-color: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.9);
}

.notifications {
  list-style: none;
  padding: 0;
	max-height: 400px;
	overflow-x: scroll;
}
.notification {
  display: block;
  padding: 9.6px 12px;
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: #eeeeee;
  background-color: #fff;
  color: #333333;
  text-decoration: none;
}
.notification:last-child {
  border-bottom: 0;
}
.notification:hover,
.notification.active:hover {
  background-color: #f9f9f9;
  border-color: #eeeeee;
}
.notification.active {
  background-color: #f4f4f4;
}
a.notification:hover {
  text-decoration: none;
}
.notification-title {
  font-size: 15px;
  margin-bottom: 0;
}
.notification-desc {
  margin-bottom: 0;
}
.notification-meta {
  color: #777777;
}
.dropdown-notifications > .dropdown-container,
.dropdown-notifications > .dropdown-menu {
  width: 450px;
  max-width: 450px;
}
.dropdown-notifications .dropdown-menu {
  padding: 0;
}

.dropdown-notifications .dropdown-footer {
  background: #eeeeee;
}
.notification-icon {
  margin-right: 6.8775px;
}
.notification-icon:after {
  position: absolute;
  content: attr(data-count);
  margin-left: -6.8775px;
  margin-top: -6.8775px;
  padding: 0 4px;
  min-width: 13.755px;
  height: 13.755px;
  line-height: 13.755px;
  background: red;
  border-radius: 10px;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  font-size: 11.004px;
  font-weight: 600;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.notification .media-body {
  padding-top: 5.6px;
}
.btn-lg .notification-icon:after {
  margin-left: -8.253px;
  margin-top: -8.253px;
  min-width: 16.506px;
  height: 16.506px;
  line-height: 16.506px;
  font-size: 13.755px;
}
.btn-xs .notification-icon:after {
  content: '';
  margin-left: -4.1265px;
  margin-top: -2.06325px;
  min-width: 6.25227273px;
  height: 6.25227273px;
  line-height: 6.25227273px;
  padding: 0;
}
.btn-xs .notification-icon {
  margin-right: 3.43875px;
}

    .table {
        background-color: #fff;
    }

    .table thead {
        background-color: #FAFAFA;
        color: #9CA2A9;
        font-weight: bold;
        text-transform: uppercase;
        font-size: 14px;
    }

    .table td {
        vertical-align: middle;
    }

    .w-40 {
        width: 40%!important;
    }

    .w-30 {
        width: 30%!important;
    }

    .w-20 {
        width: 20%!important;
    }

    .w-15 {
        width: 15%!important;
    }

    .w-10 {
        width: 10%!important;
    }

    .progress-bar {
        height: 22px;
        line-height: 22px;
    }

    .video-thumbnail {
        width: 100%;
        height: auto;
	}
	
	    .infocons i {
        font-size: 18px;
    }

    .approved {
        color: #2ecc71;
    }

		.declined {
			color: red;
		}

    .public {
        color: #2980b9;
    }


/* SIDEBAR */
	.sidebar .nav-item, .sub-menu {
		border-bottom: 1px solid rgba(255, 255, 255, 0.05);
		border-left: none;
		transition: border-left 200ms;
		width: 100%;
	}

	.sidebar .nav-item.active {
		border-left: 2px solid #fff;;
	}

	.sidebar ul :not(collapsed) .arrow:before,
	.sidebar li :not(collapsed) .arrow:before {
		font-family: FontAwesome;
		content: "\f078";
		display: inline-block;
		vertical-align: middle;
		float: right;
	}

	.sidebar .nav-item:hover {
		border-left: 4px solid #fff;
		transition: border-left 200ms;
	}

	.sub-menu {
		list-style: none;
	}

	.sub-menu li {
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.sub-menu li a {
		color: #fff;
	}

	.sub-menu li a:hover {
		text-decoration: none;
	}

	@media (max-width: 767px) {
		.sidebar {
			height: auto !important;
		}

		.sticky-top {
			position: static;
			/* top: 0; */
			/* z-index: 1020; */
		}

		.hidden {
			height: 0px;
			overflow: hidden;
			display: none;
		}

		.collapse-toggle {
			top: 22px;
			right: 10px;
			position: absolute;
			display: block !important;
		}
	}

	.collapse-toggle {
		display: none;
	}


	.modal-dialog-centered {
		-webkit-transform: translate(0,-50%) !important;
		-o-transform: translate(0,-50%) !important;
		transform: translate(0,-50%) !important;
		top: 50%;
		margin: 0 auto;
	}

	.btn-xs {

	}

	.btn-no-border {
		border: 0;
	}

	#pagination .btn-default {
		background-color: #0055A3;
		border: 0;
		color: #fff;
	}

	#pagination .btn {
		margin-left: 20px;
		margin-right: 20px;
	}

	.page-header {
		background-color: #0055A3;
		color: #fff;
		margin-bottom: 10px;
		height: 50px;
		padding-left: 10px;
		line-height: 50px;
		vertical-align: middle;
		
		/* z-index: 1000; */
		/* position: fixed; */
		/* width: 100%; */
	}

	.page-header h3 {
		font-size: 20px;
		text-transform: uppercase;
		font-weight: 500;
		vertical-align: middle;
		margin-bottom: 0px;
		line-height: 50px;
	}

	.page-header h3 button{
		margin-top: 10px;
	}

	@media (max-width: 767px) {
		.page-header {
			position: relative;
			width: initial;
		}

	}

	.btn-excel {
		background-color: #28a745;
	}







	/* custom styles */
	/* custom dropdown css stuff */
    label.dropdown_wrap {
        width: auto;
        height: auto;    
        position: relative;
        display: block;

        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
    }

    select.dropdown{
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    label.dropdown_wrap:after {
        content: "\f078 ";
        font-family: "Font Awesome 5 Pro";
        color: #000;
        font-weight: 900;
        position: absolute; 
        right: 0;
        margin-right: 1rem;
        z-index: 5;
        pointer-events: none;    
    }


	/* modal */
	.bg-smoke-dark {
        background-color: rgba(0,0,0,.5);
    }
	.pin {
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
	}

	/* transitions */

	.origin-top-right {
		transform-origin: top right;
	}
	.transition-all {
		transition-property: all;
	}
	.transition-fastest {
		transition-duration: 50ms;
	}
	.transition-faster {
		transition-duration: 100ms;
	}
	.transition-fast {
		transition-duration: 150ms;
	}
	.transition-medium {
		transition-duration: 200ms;
	}
	.ease-out-quad {
		transition-timing-function: cubic-bezier(.25, .46, .45, .94);
	}
	.ease-in-quad {
		transition-timing-function: cubic-bezier(.55, .085, .68, .53);
	}
	.scale-70 {
		transform: scale(.7);
	}
	.scale-100 {
		transform: scale(1);
	}
	.bg-gray-opacity-0 {
		background-color: rgba(0,0,0,0.0);
	}
	.bg-gray-opacity-40 {
		background-color: rgba(0,0,0,0.4);
	}
</style>